/* js/navMain.js */

jQuery( document ).ready(function( $ ) {







    $('.navMain').dropit();




    //$('.navMain').append('<i class="js_navMain_trigger navMain_trigger fa fa-bars" aria-hidden="true"></i>');


    $('<i class="js_navMain_trigger navMain_trigger fa fa-bars" aria-hidden="true"></i>').insertAfter('.navMain');




    $('body').on('click', '.js_navMain_trigger', function(){
        $('body').addClass('slideOut-open');
    });

    $('body').on('click', '.js-slideOut__close', function(){
        $('body').removeClass('slideOut-open');
    });



});